export default __webpack_public_path__ + "7498642af25dd4fffaea604bf8426adf.png";